import ContentArea from '@episerver/spa-core/Components/ContentArea';
import Page from '@episerver/spa-core/Page';
import MarketingTextBlockData from 'app/Models/Content/MarketingTextBlockData';
import TVContentsPageData from 'app/Models/Content/TVContentsPageData';
import React from 'react';
import BackgroundVideo from '../TVLobbyPage/BackgroundVideo';
import TeaserTexts from '../TVLobbyPage/TeaserTexts';
import {getVideoLink, getImageProps} from 'app/utilities/ImageProps';
import {isMobile} from 'react-device-detect';
import DesignButton from './DesignButton';

export default class TVContentsPage extends Page<TVContentsPageData> {
  render() {
    const {
      data: {
        mainContentArea,
        backgroundImage,
        mobileBackgroundImage,
        backgroundVideo,
        mobileBackgroundVideo,
        marketingTextsContentArea,
        desktopMarketingTextsContentArea,
        titleHeadlineTag,
        blockButton,
        headerButtonLink,
        isShowHeaderButton,

      },
      context,
    } = this.props;

    const teaserTexts =
      !isMobile && desktopMarketingTextsContentArea.expandedValue
        ? desktopMarketingTextsContentArea.expandedValue.map(({text, highlightText}: MarketingTextBlockData) => ({
            text: text.value,
            highlightText: highlightText.value,
          }))
        : marketingTextsContentArea.expandedValue.map(({text, highlightText}: MarketingTextBlockData) => ({
            text: text.value,
            highlightText: highlightText.value,
          }));

    const videoUrl = getVideoLink(isMobile ? mobileBackgroundVideo : backgroundVideo, context);
    const imageUrl = getImageProps(isMobile ? mobileBackgroundImage : backgroundImage, context);

    return (
      <div className='TVContentsPage'>
        <BackgroundVideo videoUrl={videoUrl} fallbackImageProps={imageUrl} />
        
        { isShowHeaderButton.value==true && 
        <DesignButton blockButton={blockButton} headerButtonLink={headerButtonLink} isShowHeaderButton={isShowHeaderButton} ownClass="top"/>
        }
        <TeaserTexts titleHeadlineTag={titleHeadlineTag} texts={teaserTexts} isTvContent={true} />
        <ContentArea noWrap data={mainContentArea} context={context} />
      </div>
    );
  }
}
